import { Navigate, useLocation } from "react-router-dom";
import { UserRole } from "../../users/enums";
import { useAuthUser } from "../hooks/useAuthUser";

export const Protected = ({ children }: { children: React.ReactElement }) => {
  const location = useLocation();

  const { initialized, user } = useAuthUser();

  // wait for store to initialize
  if (!initialized) {
    return null;
  }

  // Allow both admin and user roles to access protected routes
  if (!user || (user.role !== UserRole.Admin && user.role !== UserRole.User)) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return <>{children}</>;
};

// Admin-only wrapper for routes that should only be accessible by admins
export const AdminOnly = ({ children }: { children: React.ReactElement }) => {
  const location = useLocation();

  const { initialized, user } = useAuthUser();

  // wait for store to initialize
  if (!initialized) {
    return null;
  }

  // Only allow admin users
  if (!user || user.role !== UserRole.Admin) {
    return <Navigate to="/admin" state={{ from: location }} />;
  }

  return <>{children}</>;
};
